import { render, staticRenderFns } from "./SwitchProfileOrLogout.vue?vue&type=template&id=67db71ee&"
import script from "./SwitchProfileOrLogout.vue?vue&type=script&lang=js&"
export * from "./SwitchProfileOrLogout.vue?vue&type=script&lang=js&"
import style0 from "./SwitchProfileOrLogout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports